module.exports = __webpack_public_path__ + "img/world.ed57bb12.svg";